export default "__VITE_ASSET__H5fIDyha__"